import React, { useEffect, useState } from 'react';
import { FormInputSelect } from '../../formInputsV2/FormInputSelect';
import {
  flagResponse, inheritMeritClass, lastSixYears,
  meritClass,
  sinceFirstInsuranceYears,
  violationsResponsability,
} from '../../constants';
import { FormInputDate } from '../../formInputsV2/FormInputDate';
import getAllowedPolicyEffectDate from '../../helpers/getAllowedPolicyEffectDate';
import { FormInputRadio } from '../../formInputsV2/FormInputRadio';
import { FormInputText } from '../../formInputsV2/FormInputText';
import { calculateEmptyViolationsData } from '../../components/inputs/InputViolations';
import BersaniInfo from '../../componentsV2/elements/BersaniInfo';
import ViolationsTable from '../../formInputsV2/ViolationsTable';
import { updateViolationsFormData } from '../common/violationsCalculation';
import PaymentTypePeriod from '../../formInputsV2/PaymentTypePeriod';
import { FormLayout } from '../../formInputsV2/FormLayout.styles';
import CollapsiblePanel from '../../formInputsV2/CollapsiblePanel';
import { PrimaryButton } from '../../formInputsV2/Button.styles';
import {
  SurfaceCard, SurfaceCardCloseButton, SurfaceCardHeader, SurfaceCardHeading,
} from '../../formInputsV2/Card.styles';
import { v2Colors } from '../../formInputsV2/styles/tokens';

function RcVanStepThree({
  answers, register, isValid, errors, updateFormData, bersaniComponentRef, bersani, updateAnswers, updateBersaniData, municipalities, typeGuide, facileCompanies = [],
  showStepThreeFields = false,
  setShowStepThreeFields = () => {},
}) {
  const [newViolation, setNewViolation] = useState({
    year: '',
    type: '',
    violations: '',
  });
  const [openSinistri, setOpenSinistri] = useState(false);

  const handleNewViolationData = (name, value) => {
    setNewViolation({
      ...newViolation,
      [name]: value,
    });
  };

  useEffect(() => {
    if (answers.violations_number > 0) {
      updateFormData({
        violations: 1,
      });
    }
  }, []);

  useEffect(() => {
    if (answers.insurance_type === 'B') {
      updateFormData({
        inherit_merit_class: '',
      });
    }
  }, []);

  return (
    <div id="datiDelVeicolo" className="mx-auto index-vehicle-3">
      <FormLayout>
        <FormInputDate
          minDate={getAllowedPolicyEffectDate('min')}
          maxDate={getAllowedPolicyEffectDate('max')}
          registration={register('policy_effective_date')}
          error={errors.policy_effective_date?.message}
          valid={isValid('policy_effective_date')}
          label={
            answers.insurance_type === 'N'
              ? 'Data di inizio della copertura della polizza'
              : 'Data di scadenza della tua attuale polizza'
          }
          paragraph="Date valide: da oggi a 30 giorni da oggi"
        />

        <hr />
        <CollapsiblePanel
          open={showStepThreeFields}
          onToggle={() => setShowStepThreeFields(!showStepThreeFields)}
        >
          <FormInputRadio
            label="Ci sono altri conducenti?"
            options={flagResponse}
            name="other_drivers"
            registration={register('other_drivers')}
            error={errors.other_drivers?.message}
          />
          {answers.gender !== 'G' && (
            <>
              {answers.other_drivers === '1' && (
                <FormInputText
                  placeholder="(18 - 100)"
                  type="number"
                  min={18}
                  max={100}
                  label="Età del conducente più giovane"
                  registration={register('youngest_age_driver')}
                  error={errors.youngest_age_driver?.message}
                  valid={isValid('youngest_age_driver')}
                />
              )}
              <FormInputText
                placeholder="(18 - 100)"
                type="number"
                min={18}
                max={100}
                label="Età del membro più giovane della famiglia con la patente di guida"
                registration={register('youngest_age_family_member')}
                error={errors.youngest_age_family_member?.message}
                valid={isValid('youngest_age_family_member')}
              />
            </>
          )}
          {answers.insurance_type !== 'N' && (
            <FormInputRadio
              disabled={answers.violations_number !== 0 && answers.renew_check === true}
              label="Hai fatto sinistri negli ultimi 6 anni?"
              name="violations"
              placeholder="-Seleziona-"
              options={flagResponse}
              onChange={(value) => {
                const update_data = {
                  violations: value,
                };

                if (value === 0) {
                  update_data.violations_number = 0;
                  update_data.violations_data = calculateEmptyViolationsData();
                }

                updateFormData(update_data);
              }}
              value={answers.violations}
            />
          )}
        </CollapsiblePanel>
        {answers.insurance_type !== 'N' && (
          <FormInputSelect
            label="Prima assicurazione in 6 anni"
            registration={register('first_insuranced_year')}
            error={errors.first_insuranced_year?.message}
            valid={isValid('first_insuranced_year')}
            placeholder="-Seleziona-"
            options={lastSixYears}
          />
        )}
      </FormLayout>
      {showStepThreeFields && (
        <>
          {(Number(answers.violations) === 1 && answers.first_insuranced_year !== '' && answers.insurance_type !== 'N') && (
            <>
              {!openSinistri && <PrimaryButton className="btn btn-success mx-auto d-table" onClick={() => setOpenSinistri(!openSinistri)}>Aggiungi Sinistro</PrimaryButton>}

              {openSinistri && (
                <FormLayout>
                  <SurfaceCard>
                    <SurfaceCardHeader>
                      <SurfaceCardHeading>Nuovo sinistro</SurfaceCardHeading>
                      <SurfaceCardCloseButton type="button" aria-label="Chiudi" onClick={() => setOpenSinistri(!openSinistri)}>
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
                          <path d="M6 6l12 12M18 6L6 18" />
                        </svg>
                      </SurfaceCardCloseButton>
                    </SurfaceCardHeader>
                    <FormInputSelect
                      label="Anno Sinistro"
                      onChange={(val) => {
                        handleNewViolationData('year', val);
                      }}
                      placeholder="-Seleziona-"
                      options={sinceFirstInsuranceYears(answers.first_insuranced_year)}
                      value={newViolation.year}
                    />
                    <FormInputSelect
                      label="Responsabilita"
                      onChange={(val) => {
                        handleNewViolationData('type', val);
                      }}
                      placeholder="-Seleziona-"
                      options={violationsResponsability}
                      value={newViolation.type}
                    />
                    <FormInputText
                      type="number"
                      onChange={(val) => {
                        handleNewViolationData('violations', val);
                      }}
                      label="Numero Sinistri"
                      value={newViolation.violations}
                      placeholder="Inserisci il numero di sinistri"
                    />
                    <PrimaryButton className="btn btn-success" type="button" onClick={() => updateViolationsFormData(answers, newViolation, updateFormData, setNewViolation)}>Aggiungi</PrimaryButton>
                  </SurfaceCard>
                </FormLayout>
              )}

              <ViolationsTable violationData={answers.violations_data} />
              {errors.violations_data?.message && (
                <div
                  className="general-input-error text-center"
                  style={{
                    fontSize: 13, fontWeight: 500, color: v2Colors.danger, marginTop: 6,
                  }}
                >
                  {errors.violations_data.message}
                </div>
              )}
            </>
          )}
        </>
      )}

      <FormLayout>
        {answers.insurance_type === 'N' && (
          <FormInputSelect
            label="Puoi utilizzare la classe di merito di un altro veicolo già assicurato?"
            registration={register('inherit_merit_class')}
            error={errors.inherit_merit_class?.message}
            valid={isValid('inherit_merit_class')}
            placeholder="-Seleziona-"
            options={inheritMeritClass}
          />
        )}

        {((answers.inherit_merit_class == 'A'
          && answers.insurance_type === 'N') || answers.inherit_merit_class == 'S') && (
            <BersaniInfo
              ref={bersaniComponentRef}
              inheritMeritClass={answers.inherit_merit_class}
              bersani={bersani}
              updateBersaniData={updateBersaniData}
              municipalities={municipalities}
            />
        )}

        <FormInputSelect
          label={
            answers.inherit_merit_class == 'S'
              || (answers.inherit_merit_class == 'A'
                && answers.insurance_type === 'N')
              ? 'Classe di merito del veicolo già assicurato'
              : 'Classe di merito.'
          }
          registration={register('merit_class')}
          error={errors.merit_class?.message}
          valid={isValid('merit_class')}
          placeholder="-Seleziona-"
          options={meritClass}
          disabled={answers.insurance_type === 'N' && answers.inherit_merit_class === 'N'}
        />

        {showStepThreeFields && (
          <FormInputRadio
            label="Il conducente dichiara: di essere in possesso di patente italiana mai sospesa da 5 anni e con almeno 20 punti, di non aver mai ricevuto sanzioni per ubriachezza, di non aver modificato il veicolo."
            options={flagResponse}
            name="mofified_vehicle_and_valid_driving_license"
            onChange={(value) => updateFormData({
              mofified_vehicle: value,
              valid_driving_license: value,
            })}
            value={answers.mofified_vehicle}
            error={errors.mofified_vehicle?.message}
          />
        )}
        <FormInputSelect
          label="Tipo di guida"
          registration={register('guide_type')}
          error={errors.guide_type?.message}
          valid={isValid('guide_type')}
          placeholder="-Seleziona-"
          options={typeGuide}
        />
        {answers.insurance_type !== 'N' && (
          <FormInputSelect
            label="Compagnia assicurativa attuale"
            registration={register('previous_company')}
            error={errors.previous_company?.message}
            valid={isValid('previous_company') && Boolean(answers.previous_company)}
            placeholder="Seleziona..."
            options={facileCompanies.map((c) => ({ id: c.id, name: c.label }))}
          />
        )}
        <div className="periodicitaDeiPagamenti">
          <PaymentTypePeriod
            selectedType={answers.payment_frequency}
            updateAnswers={updateAnswers}
            error={errors.payment_frequency?.message}
          />
        </div>
      </FormLayout>
    </div>
  );
}

export default RcVanStepThree;
